import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { IPlatformFooterProps } from "./models";

const translationPath = "page.totem_start.";

export const PlatformFooter = memo(({ width, color }: IPlatformFooterProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        marginTop: 2,
        color: color ?? "white",
        display: "flex",
        justifyContent: "space-between",
        width,
      }}
    >
      <Typography variant="body2">
        {t(translationPath + "version")} 1.0
      </Typography>
      <Box sx={{ display: "flex", gap: 0.5 }}>
        <Typography variant="body2">
          {t(translationPath + "developed_by")}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: color ?? "white",
            fontWeight: "bold",
            textDecoration: "none",
          }}
        >
          {t(translationPath + "platform")}
        </Typography>
      </Box>
    </Box>
  );
});
